module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-192x192-test-e0ba9cb3d5b0707b329123e616b952b6.png";